import { useTranslations } from "use-intl";

import { AppearanceSection } from "./appearance-section";
import { LanguageSection } from "./language-section";

export function GeneralSection() {
	const t = useTranslations("settings.general");

	return (
		<section className="flex flex-col gap-6">
			<h2 className="text-muted-foreground text-lg font-medium">{t("heading")}</h2>
			<AppearanceSection />
			<LanguageSection />
		</section>
	);
}
